import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalfocusDirective } from './modalfocus-directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ModalfocusDirective],
  exports: [ModalfocusDirective]
})
export class IdpModalfocusDirectiveModule {}
